import customAxios from "../../customAxios";
import { ADMIN_ALL_SERVICE, ADMIN_DEBT_FACTORS } from "../../routes";

type Props = {
  page?: string | number;
  limit?: string | number;
  debtId?: string;
};

const getAllAdminDebtFactors = async (props: Props) => {
  var thisUrl = ADMIN_DEBT_FACTORS + "/" + props.debtId;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ ADMIN_ALL_SERVICE: error });
  }
};

export default getAllAdminDebtFactors;
